/**
 * auth.api — customer (student) account calls.
 */

import { apiClient } from '@/lib/apiClient';

export const authApi = {
  /**
   * Exchange a Google credential for our session token + account.
   * @param {string} credential - the Google ID token from the browser
   */
  googleLogin: async (credential) => {
    const envelope = await apiClient.post('/auth/google', { credential });
    return envelope.data; // { token, customer }
  },

  /** Confirm a stored token is still valid and get the current account. */
  me: async () => {
    const envelope = await apiClient.get('/auth/me');
    return envelope.data.customer;
  },

  /** Update the signed-in student's own profile. */
  updateProfile: async (patch) => {
    const envelope = await apiClient.patch('/customers/me', patch);
    return envelope.data.customer;
  },
};

export default authApi;
